import type { RequestOpts } from '@oazapfts/runtime';

import { appConfig } from '@/config';
import type { Auth } from '@/entities/auth';
import type { Me } from '@/entities/me';
import type { IActivityRepository } from '@/modules/documents/domain/repositories/activity.repository';
import type { RequestOptions } from '@/modules/documents/domain/repositories/utils/request-options';
import { UnreachableCaseError } from '@/utils/errors/unreachable-case-error';

import { FeApi } from './fetch-client';
import { ActivityRepositoryMapper } from './mappers/activity.repository.mapper';

export class FeApiActivityRepository implements IActivityRepository {
  constructor(
    private me: Me,
    private auth: Auth,
  ) {}

  private async getOpts(): Promise<RequestOpts> {
    const accessToken = await this.auth.getAccessToken();

    return {
      baseUrl: `${appConfig.bffUrl}/plex`,
      headers: {
        authorization: `Bearer ${accessToken}`,
        'x-user-email': this.me.email,
        'x-user-name': this.me.displayName,
      },
    };
  }

  async getAll(
    input: IActivityRepository.GetAllInput,
    requestOptions?: RequestOptions,
  ) {
    const opts = await this.getOpts();
    const body = ActivityRepositoryMapper.getAll.bodyFromInput(input);
    const response = await FeApi.recordsV1ActivitiesListRetrieve(body, {
      ...opts,
      signal: requestOptions?.signal,
    });

    switch (response.status) {
      case 200: {
        const activities = await ActivityRepositoryMapper.getAll.outputFromData(
          response.data,
        );

        return activities;
      }
      default: {
        throw new UnreachableCaseError(response.status);
      }
    }
  }
}
